import React, {useMemo, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {AppBar} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import useTemplateInstance from "../../../hooks/useTemplateInstance";
import {usePriceList} from "../../../../Providers/PriceListProvider";
import {useRouteMatch} from "react-router";
import {Trans, useTranslation} from "react-i18next";
import ProductPriceInfoPopup from "./ProductPriceInfoPopup";
import {formatCurrency} from "../../../../../utils";

const useStyles = makeStyles((theme) => ({
    appBarRoot: {
        backgroundColor: 'white',
        color: 'black',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        minHeight: '56px',
    },
    titleContainer: {
        flexGrow: 1,
        marginLeft: '-48px',
        '& h2': {
            fontSize: '15px',
            marginTop: 0,
            marginBottom: 0,
            lineHeight: 1,
            textAlign: 'center'
        },
        '& h4': {
            fontSize: '12px',
            marginTop: 0,
            marginBottom: 0,
            fontWeight: 'normal',
            textAlign: 'center'
        }
    },
    priceCell: {
        textAlign: 'right'
    },
    prices: {
        textDecoration: 'underline'
    }
}));

const getLowestPrice = (product) => {
    return product.productprices.reduce ( (lowestPrice, productPrice) => {
        if (productPrice.campaignprice > 0 && productPrice.campaignprice < lowestPrice) {
             return productPrice.price;
        }
        else if (productPrice.price < lowestPrice) {
            return productPrice.price;
        }
        return lowestPrice;
    }, Number.MAX_SAFE_INTEGER)
}

export default ({onCancel}) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { getPrintFormats } = usePriceList();
    const [showPriceInfo, setShowPriceInfo] = useState(false)

    const lowestPrice = useMemo( () => {
        const products = getPrintFormats();
        return products.reduce ( (lowestPrice, product) => {
            const productLowestPrice = getLowestPrice(product);
            if (productLowestPrice < lowestPrice) {
                return productLowestPrice;
            }
            return lowestPrice;
        }, Number.MAX_SAFE_INTEGER)
    }, []);

    console.log('Lowest price', lowestPrice)

    return (
        <React.Fragment>
            <AppBar classes={{root: classes.appBarRoot}} position='static' onClick={() => setShowPriceInfo(true)}>
                <div className={classes.toolbar}>
                    <IconButton onClick={onCancel}>
                        <Icon>arrow_back</Icon>
                    </IconButton>
                    <div className={classes.titleContainer}>
                        <h2>{t('Paper copies')}</h2>
                        <h4>{t('Prices from %s', {postProcess: 'sprintf', sprintf: [formatCurrency(lowestPrice)]})}
                            <span> (<span className={classes.prices}><Trans>Prices</Trans></span>)</span></h4>
                    </div>
                </div>
            </AppBar>
            <ProductPriceInfoPopup  open={!!showPriceInfo} handleClose={() => setShowPriceInfo(false)} />
        </React.Fragment>
    )
}
